'use strict';

import { view } from '@/functions';

const prefix = '/integrations';
export default [
    {
        path: prefix,
        name: 'integrations',
        meta: {
            title: 'Integrations',
            scopes: ['read_integrations', 'write_integrations']
        },
        component: () => view('integrations/index'),
    },
    {
        path: `${prefix}/:id`,
        name: 'integrations-info',
        meta: {
            title: 'Integrations',
            scopes: ['read_integrations', 'write_integrations']
        },
        component: () => view('integrations/info'),
    },
    {
        path: `${prefix}/:id/risk-report`,
        name: 'integrations-risk-report',
        meta: {
            title: 'Risk report',
            scopes: ['read_integrations', 'write_integrations']
        },
        component: () => view('integrations/risk-report'),
    }
];
